"use client";

import { c as _c } from "react/compiler-runtime";
import { IconMinus, IconPlus } from "@tabler/icons-react";
import type { Entry } from "contentful";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import type { TypeBlogCategorySkeleton } from "@/types/contentful/generated";
import { CategoryTree } from "./CategoryTree";
interface Props {
  categories: Entry<TypeBlogCategorySkeleton, undefined, string>[];
  draftMode?: boolean;
}
export const CategoryCard = t0 => {
  const $ = _c(19);
  const {
    categories,
    draftMode
  } = t0;
  const [isOpen, setIsOpen] = useState(true);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="p-6"><h2 className="text-xl font-bold leading-tight text-foreground">Categories</h2></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== categories || $[2] !== draftMode) {
    t2 = <div className="hidden lg:block">{t1}<CategoryTree categories={categories} draftMode={draftMode} /></div>;
    $[1] = categories;
    $[2] = draftMode;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isOpen) {
    t3 = isOpen ? <IconMinus className="h-4 w-4" /> : <IconPlus className="h-4 w-4" />;
    $[4] = isOpen;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-xl font-bold leading-tight text-foreground">Categories</span>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <CollapsibleTrigger asChild={true}><Button variant="ghost" className="w-full justify-start gap-2 p-0 h-auto hover:bg-transparent!">{t3}{t4}</Button></CollapsibleTrigger>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== categories || $[10] !== draftMode) {
    t6 = <CollapsibleContent className="mt-4"><CategoryTree categories={categories} draftMode={draftMode} /></CollapsibleContent>;
    $[9] = categories;
    $[10] = draftMode;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isOpen || $[13] !== t5 || $[14] !== t6) {
    t7 = <Collapsible open={isOpen} onOpenChange={setIsOpen} className="lg:hidden">{t5}{t6}</Collapsible>;
    $[12] = isOpen;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t2 || $[17] !== t7) {
    t8 = <Card className="min-w-80 lg:self-start">{t2}{t7}</Card>;
    $[16] = t2;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};